/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changePassword, encryptEmail } from "../services/helper.service";
import { useCallback, useEffect, useState } from "react";
import { useAppContext } from "../contexts/AppContext";
import { decryptText, renderPasswordHelperText } from "../helpers/index.helper";
import { CookieNames, getCookie } from "../helpers/cookie.helper";
import { Constants } from "../constants";
import { lmLogo, loginErrorIcon, passwordEyeIcon, warningIcon } from "../assets/superAdminAssets";
import uuid from "react-uuid";

const ResetPassword = () => {
    const { showLoader, hideLoader, showToaster, hideToaster } = useAppContext();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordErrors, setPasswordErrors] = useState([]);
    const [showErrorMessages, setShowErrorMessages] = useState(false);

    const [passwordValidations, setPasswordValidations] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        numeric: false,
        special: false,
    });

    useEffect(() => {
        document.title = 'Loan Mantra - Reset Password';
    }, []);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get('data')) {
            const securedEmail = decryptText(queryParams.get('data'))
            setEmail(securedEmail);
        } else {
            const securedEmail = queryParams.get('email').split(" ").join("+");
            encryptEmail(securedEmail).then(resp => setEmail(resp)).catch(err => console.log(err));
        }
        validatePassword(password);
    }, []);

    const validatePassword = (password) => {
        const validations = {
            length: password.length >= 8,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            numeric: /\d/.test(password),
            special: /[@$%^&*!#]/.test(password),
        };
        const errors = Object.keys(validations).filter((key) => !validations[key]);
        setPasswordValidations(validations);
        setPasswordErrors(errors);
        return errors;
    };

    const handlePasswordChange = useCallback((e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        validatePassword(newPassword);
        setShowErrorMessages(false);
    }, []);

    const handleConfirmPasswordChange = useCallback((e) => {
        setConfirmPassword(e.target.value);
        setShowErrorMessages(false);
    }, []);

    const showPassword = (inputId, eyeId) => {
        const input = document.getElementById(inputId);
        const eyeIcon = document.getElementById(eyeId);
        input.type = input.type === 'password' ? 'text' : 'password';
        eyeIcon.classList.toggle('active_pass');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validatePassword(password);
        if (errors.length > 0) {
            setShowErrorMessages(true);
            return;
        }

        if (password !== confirmPassword) {
            setShowErrorMessages(true);
            return;
        }

        showLoader();

        const requestData = {
            EmailAddress: email,
            SessionId: getCookie(CookieNames.SESSION_ID) ?? uuid(),
            Password: password,
        };

        try {
            const { status, message } = await changePassword(requestData);
            if (status === 200) {
                showToaster(message, status === 200 ? "success" : "error");
                setTimeout(() => hideToaster(), Constants.TOASTERHIDETIME);
                navigate('/');
            }
        } catch (err) {
            showToaster(err.response?.data?.message || "An error occurred", "error");
            setTimeout(() => hideToaster(), Constants.TOASTERHIDETIME);
        } finally {
            hideLoader();
        }
    };

    return (
        <>

            <div className="website-wrap">
                <section className="forgot-body">
                    <div className='pb-4 text-center'>
                        <img src={lmLogo} alt="" />
                    </div>
                    <div className="container">
                        <div className="forgot-box verification-box">
                            <h4>Reset Password</h4>
                            <p>{email}</p>

                            {(showErrorMessages && password && password !== confirmPassword) && (
                                <div className="password-match-toast d-flex justify-content-center">
                                    <img className="mr-2" src={warningIcon} alt="" />
                                    Passwords must match
                                </div>
                            )}

                            {showErrorMessages && passwordErrors.length > 0 && (
                                <div className="password-match-toast d-flex justify-content-center">
                                    <img className="mr-2" src={warningIcon} alt="" />
                                    Password validations failed
                                </div>
                            )}

                            <div className="form-group input-password">
                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    value={password}
                                    onChange={handlePasswordChange}
                                    placeholder="Enter a password"
                                />
                                <img
                                    onClick={() => showPassword("password", "pass_eye")}
                                    id="pass_eye"
                                    className="pass_eye"
                                    src={passwordEyeIcon}
                                    alt="Toggle Password Visibility"
                                />
                                {renderPasswordHelperText(passwordValidations)}
                            </div>

                            <div className="form-group input-password">
                                <label htmlFor="confirm-password">Confirm Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="confirm-password"
                                    value={confirmPassword}
                                    onChange={handleConfirmPasswordChange}
                                    placeholder="Confirm your password"
                                />
                                <img
                                    onClick={() => showPassword("confirm-password", "confirm_pass_eye")}
                                    id="confirm_pass_eye"
                                    className="pass_eye"
                                    src={passwordEyeIcon}
                                    alt="Toggle Confirm Password Visibility"
                                />
                            </div>

                            <button type="button" className="btn btn-forgot" onClick={handleSubmit}>
                                Reset Password
                            </button>
                            <div className="text-center mt-4 mobile-only-link">
                                <Link className="link-secondary" to="/">Back to Login</Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default ResetPassword;